import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import {  getDefaultColumnOrderIds, MaterialReactTable } from 'material-react-table';
import axios from 'axios';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
// import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

import { jsPDF } from 'jspdf'; //or use your library of choice here
import autoTable from 'jspdf-autotable';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CloseIcon from '@mui/icons-material/Close'
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import TableRowsIcon from '@mui/icons-material/TableRows';

// import { KeyboardArrowUpIcon, KeyboardArrowDownIcon, CloseIcon, FileDownloadIcon, DownloadOutlined, PictureAsPdfIcon, SaveIcon , DragHandleIcon} from '@mui/icons-material'
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { IconButton, Popover , Typography, FormControl, Select,  Box, MenuItem, TextField, Alert, Paper, InputBase, Checkbox,  Grid ,
  Switch, List, ListItem, ListItemButton, ListItemText, ListSubheader, InputLabel, Button, Divider, Tooltip, FormGroup, FormControlLabel, Snackbar} from "@mui/material";
import { handleExcelDownload, s2ab } from "./downloadExcel";


/* global tableau */
const MaterialTable = ({ columnLayouts, user , workbook , defaultLayout,  sheet, defaultLayoutName }) => {
  // console.log(columnLayouts)
    const [extensionJson, setExtensionJson] = useState(columnLayouts)
    const [columnIDs, setColumnIDs] = useState([])
    const [rows,setOrgRows] = useState([])
    const [headers, setOrgHeaders] = useState([])

    const [columnOrder, setColumnOrders] = useState(columnLayouts.sessionLayout.columnOrder)
    const [columnSizing, setColumnWidths] = useState(columnLayouts.sessionLayout.columnSizing)
    const [columnVisibility, setColumnVisibility] = useState(columnLayouts.sessionLayout.columnVisibility)
    const [selectedColumnLayout, setSelectedColumnLayout] = useState(defaultLayoutName)

    useEffect(()=>{ columnIDsRef.current = columnIDs },[columnIDs])
    // useEffect(()=>{ console.log(headers) },[headers])


    const columnIDsRef = useRef(columnIDs)
    const columnOrderRef = useRef(columnOrder)
    const columnVisibilityRef = useRef(columnVisibility)
    const maxRowsRef = useRef(null)
    const selectedRowsRef = useRef(10000)
    const columnTotalRef = useRef(null);
    const selectedColumnLayoutRef=useRef('')

    const columnsRef = useRef([])
    const dataRef = useRef([])

    const [formColumnOrder, setFormColumnOrders] = useState(columnLayouts.sessionLayout.columnOrder)
    const [formColumnVisibility, setFormColumnVisibility] = useState(columnLayouts.sessionLayout.columnVisibility)
    const [columnsForTotal, setColumnsForTotal] = useState([])
    const [fixedColumns, setFixedColumns] = useState([])

    const [isLoading, setIsLoading] = useState(true);
    const [sorting, setSorting] = useState([]);

    const rowVirtualizerInstanceRef = useRef(null);


        //Pop-over
        const [anchorEl, setAnchorEl] = React.useState(null);
        const [saveAnchorEl, setSaveAnchorEl] = React.useState(null);
        const [downloadAnchorEl, setDownloadAnchorEl] = React.useState(null);
        const [totalAnchorEl, setTotalAnchorEl] = React.useState(null);

      
        const open = Boolean(anchorEl);
        const saveOpen = Boolean(saveAnchorEl)
        const downloadOpen = Boolean(downloadAnchorEl)
        const totalOpen = Boolean(totalAnchorEl)

      
        const id = open ? 'simple-popover' : undefined;
        const saveId = open ? 'simple-popover' : undefined;
        const downloadId = open ? 'simple-popover' : undefined;
        const totalId = open ? 'simple-popover' : undefined;
      
        const handleClose = () => setAnchorEl(false) 
        const handleSaveClose = () => setSaveAnchorEl(false) 
        const handleDownloadClose = () => setDownloadAnchorEl(false) 
        const handleTotalClose = () => setTotalAnchorEl(false)

        const [progress, setProgress] = useState(0)
        const [progressBar, setProgressBar] = useState(false)

        let unregisterEventFn

        useEffect( () => {   
           fetchData (columnLayouts.sessionLayout)  
           currencyParam()
          }, [])


          const currencyParam = async () => {
            const parameters = await tableau.extensions.dashboardContent.dashboard.getParametersAsync()
            const currencyParam = parameters.find(param => param.name === 'Currency');
            const totalParam = parameters.find(param => param.name === 'TotalParameter');
            const downloadParam = parameters.find(param => param.name === 'DownloadParameter');
            const fixedColumnsParam = parameters.find(param => param.name === 'FixedColumnsParameter');


            if (totalParam) setColumnsForTotal(JSON.parse(totalParam.currentValue.formattedValue)) 
            if (fixedColumnsParam) setFixedColumns(JSON.parse(fixedColumnsParam.currentValue.formattedValue)) 

            
            if (currencyParam) {
                currencyParam.addEventListener(tableau.TableauEventType.ParameterChanged, function (selectionEvent) {
                              setIsLoading(true)
                              setOrgRows([])
                              fetchData('filter');
                              setProgress(0)
                })
            }

            if (downloadParam) {
              downloadParam.addEventListener(tableau.TableauEventType.ParameterChanged, function (selectionEvent) {
                downloadTrigger()
              })
          }
          }

          const filterAndOrderColumns = (visibleColumns, presentColumnOrder) => {
            const filedColumnsSet = new Set(visibleColumns);
            return presentColumnOrder.filter(column => filedColumnsSet.has(column));
          }

        const fetchData = useCallback ( async (sessionLayout, maxSelect) => {
          if (unregisterEventFn) unregisterEventFn()
          const worksheet   = await tableau.extensions.dashboardContent.dashboard.worksheets.find(worksheet => worksheet.name === sheet)
          const pageRowCount = 10000
          let visibleColumnsbyID
          if (sessionLayout != 'filter') {
            const dataTableReaderAllColumn = await worksheet.getSummaryDataReaderAsync(pageRowCount, { includeDataValuesOption: tableau.IncludeDataValuesOption.OnlyFormattedValues , columnsToIncludeById : [] ,  })
            const allColumnsIds = await dataTableReaderAllColumn.getPageAsync(0)
            let AllColumnFieldNames = allColumnsIds.columns.map(column => column._fieldName.trim())
            if (columnOrder.length === 0)
            {
            setColumnOrders(AllColumnFieldNames)
            }
            let columnIds =  Object.keys(sessionLayout.columnVisibility)
                visibleColumnsbyID = allColumnsIds.columns.filter(column => !columnIds.includes(column._fieldName.trim())).map(column => column._fieldId);
            const visibleColumnsbyName = allColumnsIds.columns.filter(column => !columnIds.includes(column._fieldName.trim())).map(column => column._fieldName.trim());
            // console.log(visibleColumnsbyName)
            const filteredAndOrderedColumns = filterAndOrderColumns(visibleColumnsbyName,  sessionLayout.columnOrder);
            setColumnIDs(visibleColumnsbyID)
            setColumnVisibility(sessionLayout.columnVisibility)
            setColumnWidths(sessionLayout.columnSizing)
            setColumnOrders(filteredAndOrderedColumns)
          }
          if (sessionLayout === 'filter') visibleColumnsbyID = columnIDsRef.current
          const dataTableReader = await worksheet.getSummaryDataReaderAsync(pageRowCount, { includeDataValuesOption: tableau.IncludeDataValuesOption.OnlyFormattedValues , columnsToIncludeById : visibleColumnsbyID })
          // console.log(dataTableReader)
          maxRowsRef.current = dataTableReader.totalRowCount
          if (maxSelect) selectedRowsRef.current = dataTableReader.totalRowCount
          let updatedRows = []
          for (let currentPage = 0; currentPage < dataTableReader.pageCount; currentPage++) {
            // console.log((selectedRowsRef.current / 10000) , currentPage )
            if ( ((selectedRowsRef.current / 10000) > currentPage) || currentPage === 0) {
              // console.log('here', (selectedRowsRef.current / 10000) , currentPage)
                const currentPageDataTable = await dataTableReader.getPageAsync(currentPage);
                const header = currentPage === 0 ? currentPageDataTable.columns : headers;  // Use orgHeaders for non-first pages
                const rowsFromPage = currentPageDataTable.data.map(row => row.map(cell => cell.formattedValue));
                const progressLevel = ((currentPage + 1) / dataTableReader.pageCount) * 100;
        
                if (currentPage === 0) {
                    setOrgHeaders(header);
                    setProgressBar(true);
                }
        
                updatedRows = [...updatedRows, ...rowsFromPage]
                setOrgRows(updatedRows);
                setProgress(progressLevel);
        
                if (progressLevel >= 100) {
                    setProgressBar(false);
                    setIsLoading(false);
                }
            } else {
              setProgressBar(false);
              setIsLoading(false);
            }
        }
        
          await dataTableReader.releaseAsync()
            unregisterEventFn = worksheet.addEventListener(tableau.TableauEventType.FilterChanged, (filter) => {
              setIsLoading(true)
              fetchData('filter')
              setProgress(0)
            })
      }, [] )

     const handlePageLimitSelect = (e) => {
      selectedRowsRef.current = e.target.value
      let maxSelect
      if (selectedRowsRef.current === maxRowsRef.current) maxSelect = true 
      fetchData('filter', maxSelect)
     }

      useEffect(() => { if(progress === 100) setProgressBar(false) },[progress])
      useEffect(() => { if (!extensionJson.developer) updateData(extensionJson.customLayouts) }, [extensionJson.customLayouts])
      useEffect(() => { if (extensionJson.developer){ updateData(extensionJson.preDefinedLayouts) } }, [extensionJson.preDefinedLayouts])
      useEffect(()=>{ 
        selectedColumnLayoutRef.current = selectedColumnLayout.split("~")[0]
      },[selectedColumnLayout])

      const updateData = async (layoutSettings, defaultLayout) => { 
        // console.log(layoutSettings)
        await loadCustomLayoutsToDB(layoutSettings, defaultLayout) 
      }

      const loadCustomLayoutsToDB = async (customLayouts, defaultLayout) => {
      
      // Destructure necessary constants (Assuming `user`, `workbook`, `defaultLayoutOther` are defined in the scope)
      const dbPayload = { mycustomLayouts: {}, sharedLayoutsofUser: {}, defaultLayout: defaultLayout ? defaultLayout : defaultLayoutOtherRef.current };
  
      // Separate layouts based on visibility
      for (const [layoutName, layoutDetails] of Object.entries(customLayouts)) {
          layoutDetails.isVisibleToOthers ? dbPayload.sharedLayoutsofUser[layoutName] = layoutDetails  : dbPayload.mycustomLayouts[layoutName] = layoutDetails;
        }
      
      // Prepare payload for the API request
      const payload = { user_name: user, wb_name: workbook, layout_settings: dbPayload }
      // Prepare input parameters for the API request
      const inputParams = { data: payload };
  
      try {
          // Fetch token and perform update request in parallel
          const tokenPromise = axios.post('/api/generateToken', { username: 'extensionApi' });
          const [tokenResponse] = await Promise.all([tokenPromise]);
                inputParams.tokens = `Bearer ${tokenResponse.data.token}`;
  
          const updateResponse = await axios.post('/api/updateAllCustomLayouts', { inputParams });
      } catch (error) {
          console.error("Error updating custom layouts:", error.message);
      }
  };
      

  const Columns = useMemo(() => {
    const columnSums = {}
    const columnDefinitions = Object.entries(headers).map(([headerKey, { _dataType, _fieldName }]) => {
        const isFloat = _dataType === 'float' 
        let columnHeader = _fieldName.trim()
        if (_fieldName.startsWith('AGG(') || _fieldName.startsWith('SUM(')) {
            const firstParenthesisIndex = _fieldName.indexOf('(');
            const lastParenthesisIndex = _fieldName.lastIndexOf(')');
            if (firstParenthesisIndex !== -1 && lastParenthesisIndex !== -1 && lastParenthesisIndex > firstParenthesisIndex) {
                  columnHeader = _fieldName.substring(firstParenthesisIndex + 1, lastParenthesisIndex);
            }
        }
    
        const column = {
            header: columnHeader,
            accessorKey: _fieldName.trim(),
            size: 120,
        };
    
        if (isFloat && columnsForTotal.includes(_fieldName.trim())) columnSums[_fieldName.trim()] = 0;
        return column;
    });
        // console.log("Here", columnsForTotal)
    
    rows.forEach((row) => {
    Object.entries(row).forEach(([columnIndex, value]) => {
        const header = headers[columnIndex]
        const { _dataType, _fieldName } = header

        if (_dataType === 'float' && columnsForTotal.includes(_fieldName.trim())) {
        const newValue = value.replace(/,/g, '')
        const cellValue = parseFloat(newValue)
        if (!isNaN(cellValue)) {
            columnSums[_fieldName.trim()] += cellValue
        }
        }
    });
    });

    columnDefinitions.forEach((column) => {
    if (column.accessorKey in columnSums) {
        column.Footer = (
        <>
            {columnSums[column.accessorKey].toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            })}
        </>
        );
    }
    });
    columnsRef.current = columnDefinitions
    return columnDefinitions
}, [headers, rows, columnsForTotal])

  const data = useMemo(() => {
    const dataWithHeader =  rows.map((row) =>
    headers.reduce((rowData, header, i) => {
        rowData[header._fieldName.trim()] = row[i];
        return rowData;
    }, {})
    );
      dataRef.current = dataWithHeader
      return dataWithHeader
  }, [headers, rows])

  const rearrangeKeys = (row, columnOrders) => {
    const newRow = {};
      columnOrders.forEach(key => {
      if (key in row) {
        newRow[key] = row[key];
      }
    });
    return newRow;
  };

  const downloadTrigger = async () => {
    const parameters = await tableau.extensions.dashboardContent.dashboard.getParametersAsync()
    const downloadParam = parameters.find(param => param.name === 'DownloadParameter');
    // console.log(downloadParam)
    const formatValue = downloadParam.currentValue.formattedValue.split("~")[1]

    if (formatValue) {
      const rearrangedRows = dataRef.current.map(row => rearrangeKeys(row, columnOrderRef.current));
      const lastRow = {}
  
      columnsRef.current.forEach((column) => {   
        let columnName
             if (column.accessorKey.startsWith("SUM") || column.accessorKey.startsWith("AGG")) 
                {
                    let match = column.accessorKey.match(/\(([^)]+)\)/);
                    columnName = match[1]
                }  
              else columnName = column.accessorKey
            if  (column.Footer ) lastRow[columnName] = column.Footer.props.children 
            else lastRow[columnName] = '' 
       })
  
       const keyToHeaderMap = columnsRef.current.reduce((acc, column) => {
          acc[column.accessorKey] = column.header
          return acc
        }, {});
      
      let transformedRows = rearrangedRows.map(row => {
        const newRow = {};
        Object.keys(row).forEach(key => {
          const header = keyToHeaderMap[key.trim()];
          if (header) {
            newRow[header] = row[key];
          }
        });
        return newRow;
      });
      transformedRows.push(lastRow)

      if (formatValue === 'csv') {
        downloadParam.changeValueAsync(sheet)
       const csvConfig = mkConfig({    fieldSeparator: ',',    decimalSeparator: '.',    useKeysAsHeaders: true,    filename: selectedColumnLayoutRef.current  })
        download(csvConfig)(generateCsv(csvConfig)(transformedRows))
      } else if ( formatValue === 'excel') {
        downloadParam.changeValueAsync(sheet)
        let excelFileName = selectedColumnLayoutRef.current + ".xlsx"
        handleExcelDownload(transformedRows , excelFileName )
      }
    }
  }

  const [newFormOpen, setNewFormOpen] = useState(false); // State to track which item is being edited

  const setNewForm = (e) => {
    setEditForm(false)
    setNewFormOpen(true)
    setColumnLayoutName('')
    setColumnLayoutNotes('')
    setIsVisibleToOthers(false)
    setIsDefaultColumn(false)
  }

  const [ColumnFormStatus, setColumnFormStatus] = useState('');

const handleColumnsPopClick = (event, layout) => {
  setAnchorEl(event.currentTarget);
  setSaveAnchorEl(null);

  const selectedLayout = layout || selectedColumnLayout.split("~")[0];
  setSelectedColumnLayout(layout ? `${layout}~customLayouts` : selectedColumnLayout);

  // Determine if the form is editable based on layout types
  if (!extensionJson.developer) {
    const isEditable = extensionJson.preDefinedLayouts?.[selectedLayout] || extensionJson.otherLayouts?.[selectedLayout];
    setEditForm(!!isEditable);
  } else if (extensionJson.customLayouts?.[selectedLayout]) {
    setEditForm(false);
  }

  let layoutDetails;
  if (extensionJson.preDefinedLayouts?.[selectedLayout]) {
    setColumnFormStatus('Predefined Layout');
    layoutDetails = extensionJson.preDefinedLayouts[selectedLayout];
  } else if (extensionJson.otherLayouts?.[selectedLayout]) {
    setColumnFormStatus('Other Layout');
    layoutDetails = extensionJson.otherLayouts[selectedLayout];
  } else if (extensionJson.customLayouts?.[selectedLayout]) {
    setColumnFormStatus('Custom Layouts');
    layoutDetails = extensionJson.customLayouts[selectedLayout];
  }

  if (layoutDetails) {
    setSelectedColumns([]);
    setNewFormOpen(false);
    setFormColumnOrders(layoutDetails.columnOrder);
    setFormColumnVisibility(layoutDetails.columnVisibility);
    handlelayoutDetails(selectedLayout, layoutDetails);
  }
}
   
   const [searchQuery, setSearchQuery] = useState('');
   const [isMultiCheckSwitch, setMultiCheckSwitch] = useState(true)
   const [selectedColumns,setSelectedColumns] = useState([])
  
    const handleInputChange = (e) =>  setSearchQuery(e.target.value.toLowerCase())
    
    const moveUp = () => {
      let newupdatedColumnOrder = [...formColumnOrder]; // Create a copy
      let selectedIndices = selectedColumns.map(value => newupdatedColumnOrder.indexOf(value)).filter(index => index !== -1).sort((a, b) => a - b)       
        selectedIndices.forEach((index) => {
          if (index > 0 && index < newupdatedColumnOrder.length) {
            const temp = newupdatedColumnOrder[index]
            newupdatedColumnOrder[index] = newupdatedColumnOrder[index - 1]
            newupdatedColumnOrder[index - 1] = temp
          }})

      setFormColumnOrders(newupdatedColumnOrder)
    //  setColumnOrders(newupdatedColumnOrder)
    }
    
    const moveDown = () => {
      let newupdatedColumnOrder = [...formColumnOrder]; // Create a copy
      let selectedIndices = selectedColumns.map(value => newupdatedColumnOrder.indexOf(value)).filter(index => index !== -1).reverse().sort((a, b) => b - a)
        selectedIndices.forEach((indice) => {
          if (indice < newupdatedColumnOrder.length - 1 ) {
            const temp = newupdatedColumnOrder[indice]
            newupdatedColumnOrder[indice] = newupdatedColumnOrder[indice + 1]
            newupdatedColumnOrder[indice + 1] = temp
          }})
      setFormColumnOrders(newupdatedColumnOrder)
      // setColumnOrders(newupdatedColumnOrder); // Update the state with the new array
    }
  
    const filteredColumns = formColumnOrder.filter((name) => name.toLowerCase().includes(searchQuery.toLowerCase()) )

    const handleColumnClick = (value) => {
      const index = selectedColumns.indexOf(value);
        if (index !== -1) {
          const updatedColumns = [...selectedColumns];
          updatedColumns.splice(index, 1);
          setSelectedColumns(updatedColumns);
        } else {
          setSelectedColumns([...selectedColumns, value]);
        }
    
     }
       
   const handleSwitchToggle = (value) => () => {
    const newColumnVisibility = { ...formColumnVisibility }
    newColumnVisibility.hasOwnProperty(value) ? delete newColumnVisibility[value] : newColumnVisibility[value] = false
    setFormColumnVisibility(newColumnVisibility)
  }

   const handleSwitchTotalToggle = (column) => {
    const columnsTotal = [...columnsForTotal];
    const index = columnsTotal.indexOf(column);
    if (index > -1) {
      columnsTotal.splice(index, 1);
    } else {
      columnsTotal.push(column);
    }
    setColumnsForTotal(columnsTotal);
    updateTotalParam(columnsTotal)
   }

   const handleSwitchFixedColumnsToggle = (column) => {

    const fixedColumnList = [...fixedColumns];
    const index = fixedColumnList.indexOf(column);
    if (index > -1) {
      fixedColumnList.splice(index, 1);
    } else {
      fixedColumnList.push(column);
    }
    setFixedColumns(fixedColumnList);
    updateFixedColumnParam(fixedColumnList)
    
   }


   const updateTotalParam = async (columnsTotal) => {
    const stringifiedColumnsTotal = JSON.stringify(columnsTotal);
    const parameter = await tableau.extensions.dashboardContent.dashboard.getParametersAsync().then((parameters) => { return parameters.find((p) => p.name === 'TotalParameter')})
                  parameter.changeValueAsync(stringifiedColumnsTotal)
   }

   
   const updateFixedColumnParam = async (fixedColumnList) => {
    const stringifiedColumnsFixed = JSON.stringify(fixedColumnList);
    const parameter = await tableau.extensions.dashboardContent.dashboard.getParametersAsync().then((parameters) => { return parameters.find((p) => p.name === 'FixedColumnsParameter')})
                  parameter.changeValueAsync(stringifiedColumnsFixed)
   }
     const handleBulkToggle = (e) => {
      setMultiCheckSwitch(!isMultiCheckSwitch);
      if(isMultiCheckSwitch){
          const updatedVisibility = {...formColumnVisibility}
          selectedColumns.forEach(column => { updatedVisibility[column] = false })
          setFormColumnVisibility(updatedVisibility)
      } else {
          const updatedVisibility = {...formColumnVisibility};
          selectedColumns.forEach(column => { delete updatedVisibility[column]  })
          setFormColumnVisibility(updatedVisibility)
      }
  }
  

  
    const extractValueInsideParentheses = (name) => {
      
      if (name.startsWith('AGG(') || name.startsWith('SUM(')) {
          // const match = name.match(/\(([^)]+)\)/);
          // return match ? match[1] : name;
          const firstParenthesisIndex = name.indexOf('(');
          const lastParenthesisIndex = name.lastIndexOf(')');
          if (firstParenthesisIndex !== -1 && lastParenthesisIndex !== -1 && lastParenthesisIndex > firstParenthesisIndex) {
              let  columnHeader = name.substring(firstParenthesisIndex + 1, lastParenthesisIndex);
                return columnHeader
          }
      }
      return name;
    }

  const handleDragEnd = (result) => {
    if (!result.destination)  return
    const reorderedColumns = Array.from(formColumnOrder);
    const [movedColumn] = reorderedColumns.splice(result.source.index, 1)

    reorderedColumns.splice(result.destination.index, 0, movedColumn)
    setFormColumnOrders(reorderedColumns)
  }


const handleLayoutFormClick = (e) => {
  setSaveAnchorEl(e.currentTarget)
  setColumnLayoutName('')
  setColumnLayoutNotes('')
  setIsVisibleToOthers(false)
  setIsDefaultColumn(false)
  setEditForm(true)
}

const handleColumnSelect = (e) => {
  const [selectedLayout, layoutPosition] = e.target.value.split("~")
  const layoutDetails = extensionJson[layoutPosition][selectedLayout]
  setSelectedColumnLayout(e.target.value)
  handlelayoutDetails(selectedLayout, layoutDetails)
}

const handlelayoutDetails = (selectedLayout, layoutDetails, noLoad) => {
  const isDefaultLayout = Object.keys(defaultLayoutOther).length !== 0 && columnLayoutName.split("~")[0] === defaultLayoutOther.layoutName
  
  setColumnLayoutName(selectedLayout)
  setColumnLayoutNotes(layoutDetails.columnNotes)
  setIsVisibleToOthers(layoutDetails.isVisibleToOthers)
  setIsDefaultLayout(isDefaultLayout) 
  setIsDefaultColumn(layoutDetails.isDefault)
  setProgress(0)
  if (!noLoad) fetchData(layoutDetails)
 }

const handleCancel = () => {
  setAnchorEl (null)

  const selectedLayout = selectedColumnLayout.split("~")[0];
  const layoutDetails = extensionJson.preDefinedLayouts[selectedLayout] ?? extensionJson.customLayouts[selectedLayout] ?? extensionJson.otherLayouts[selectedLayout];
  handlelayoutDetails(selectedLayout, layoutDetails, 'cancel')
}

const [columnLayoutName, setColumnLayoutName] = useState(defaultLayoutName);
const [columnLayoutNotes, setColumnLayoutNotes] = useState(columnLayouts.columnNotes);
const [isVisibleToOthers, setIsVisibleToOthers] = useState(columnLayouts.isVisibleToOthers);
const [isDefaultColumn, setIsDefaultColumn] = useState(columnLayouts.isDefault);
const [LayoutAlert, setLayoutAlert] = useState(false);
const [LayoutAlertStatus, setLayoutAlertStatus] = useState('success');
const [LayoutAlertMsg, setLayoutAlertMsg] = useState('');

const handleSnackbar = (event, reason) => {
  if (reason === 'clickaway') {
      setLayoutAlert(false);
    return;
  }

  setLayoutAlert(false);
};

const savedefColumnLayout = () => {
  const [currentLayout, currentLayoutPosition] = selectedColumnLayout.split("~");
  const layoutDetails = extensionJson?.[currentLayoutPosition]?.[currentLayout];
  
  if (isDefaultLayout) {
    const ownerName = currentLayoutPosition === 'otherLayouts' ? layoutDetails?.user_name : "Admin"
    setDefaultLayoutOther({ layoutName: currentLayout, owner: ownerName });
  } else if (currentLayout === defaultLayoutOther.layoutName) {
    setDefaultLayoutOther({});
  }
  
  setAnchorEl(null);
}

function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false;
  }
  return true;
}

const saveColumnLayout = () => {
  const columnSetting = columnLayoutName.trim().toLowerCase();
  setColumnOrders(columnOrderRef.current)
  setColumnVisibility(columnVisibilityRef.current)
  // Combine all layout keys into a single set for quick lookup
  const allLayoutKeys = new Set([
      ...Object.keys(extensionJson.preDefinedLayouts).map(key => key.toLowerCase()),
      ...Object.keys(extensionJson.customLayouts).map(key => key.toLowerCase()),
      ...Object.keys(extensionJson.otherLayouts).map(key => key.toLowerCase())
  ]);
  // console.log(allLayoutKeys.has(columnSetting))
  if (allLayoutKeys.has(columnSetting)) {
      const isDeveloper = extensionJson.developer;
      const layoutSource = isDeveloper ? "preDefinedLayouts" : "customLayouts";
      const layouts = extensionJson[layoutSource];
      const match = Object.keys(layouts).find(key => key.toLowerCase() === columnSetting);
      if (match) {
          if (match === columnLayoutName.trim()) {
            const extensionJsonObj = extensionJson[layoutSource][match]
            const layoutState = { 
                columnOrder: formColumnOrder,
                columnSizing: columnSizing,
                columnVisibility: formColumnVisibility,
                columnNotes: columnLayoutNotes,
                isVisibleToOthers: isVisibleToOthers,
                isDefault: isDefaultColumn
              }
                if (deepEqual(extensionJsonObj, layoutState)) {
                  setAnchorEl(null);
                } else {
                    const selectLayoutValue = `${columnLayoutName.trim()}~${layoutSource}`;
                    setSelectedColumnLayout(selectLayoutValue);
                    updateExtJson(isDeveloper ? "preDefined" : "custom", match, columnLayoutName.trim());
                    setAnchorEl(null);
                    setLayoutAlert(true);
                    setLayoutAlertStatus('success');
                    setLayoutAlertMsg('Layout Updated Successfully');
                }
          }
      } else {
          const errorSource = !isDeveloper && Object.keys(extensionJson.otherLayouts).find(key => key.toLowerCase() === columnSetting) ? "otherLayouts" : "preDefinedLayouts"
          setLayoutAlertMsg(`Layout Name Exists in ${errorSource === "preDefinedLayouts" ? "Predefined" : "Other"} Layouts`);
          setLayoutAlert(true);
          setLayoutAlertStatus('error');
      }
  } else {
    
      const isDeveloper = extensionJson.developer;
      const layoutSource = isDeveloper ? "preDefinedLayouts" : "customLayouts";
      const rename = newFormOpen ? null : columnLayoutName.trim();
      const selectName = newFormOpen ? columnLayoutName.trim() : selectedColumnLayout.split("~")[0];
      const selectLayoutValue = `${columnLayoutName.trim()}~${layoutSource}`;

      setSelectedColumnLayout(selectLayoutValue);
      updateExtJson(extensionJson.developer ? "preDefined" : "custom", selectName, rename);
      setAnchorEl(null);
      setLayoutAlert(true);
      setLayoutAlertStatus('success');
      setLayoutAlertMsg(newFormOpen ? 'Layout Added Successfully' : 'Layout Updated Successfully');
  }
}


useEffect(() => {
  let objectIdentifer = "columnSizing";
  updateExtJson(objectIdentifer, columnSizing)
}, [columnSizing])

useEffect(() => {
  let objectIdentifer = "columnOrder";
  updateExtJson(objectIdentifer, columnOrder)
}, [columnOrder])

useEffect(() => {  
    let newupdatedColumnOrder = [...formColumnOrder]
    const keysToRemove = Object.keys(formColumnVisibility)
    const filteredColumnOrder = newupdatedColumnOrder.filter(item => !keysToRemove.includes(item))
    columnOrderRef.current = filteredColumnOrder 
}, [formColumnOrder])

useEffect(() => {  
  columnVisibilityRef.current = formColumnVisibility 
}, [formColumnVisibility])

useEffect(() => {
  let objectIdentifer = "columnVisibility"
  updateExtJson(objectIdentifer, columnVisibility)
}, [columnVisibility]);

const updateExtJson = (identifier, data, newName) => {
  // console.log(identifier, data, newName)
  const layoutState = { 
    columnOrder: formColumnOrder,
    columnSizing: columnSizing,
    columnVisibility: formColumnVisibility,
    columnNotes: columnLayoutNotes,
    isVisibleToOthers: isVisibleToOthers,
    isDefault: isDefaultColumn
  };

  const updateLayouts = (prevState, layouts) => {
    const updatedLayouts = { ...layouts };
    // console.log(prevState, layouts)
    if (layoutState.isDefault) {
      for (const key in updatedLayouts) {
        if (updatedLayouts[key]?.isDefault) updatedLayouts[key].isDefault = false;
      }
      setDefaultLayoutOther({});
    }

    if (newName && data in updatedLayouts) delete updatedLayouts[data];
    if (extensionJson.developer) { return { ...prevState, preDefinedLayouts: { ...updatedLayouts, [newName || data]: layoutState } }; }
    else {return { ...prevState, customLayouts: { ...updatedLayouts, [newName || data]: layoutState } };}
  }

  switch (identifier) {
    case 'columnOrder':
    case 'columnSizing':
    case 'columnVisibility':
      setExtensionJson(prevState => ({
        ...prevState,
        sessionLayout: { ...prevState.sessionLayout, [identifier]: data }
      }));
      break;

    case 'preDefined':
      setExtensionJson(prevState => updateLayouts(prevState, prevState.preDefinedLayouts));
      break;
    case 'custom':
      setExtensionJson(prevState => updateLayouts(prevState, prevState.customLayouts));
      break;

    default:
      console.warn(`Unhandled identifier: ${identifier}`);
      break;
  }
};


const [editForm, setEditForm] = useState(false);
const [defaultLayoutOther, setDefaultLayoutOther] = useState(defaultLayout)
const defaultLayoutOtherRef = useRef(defaultLayout)
const [isDefaultLayout , setIsDefaultLayout] = useState(false)

useEffect(() => { 
            if (extensionJson.developer) {
                updateData(extensionJson.preDefinedLayouts, defaultLayoutOther)
                defaultLayoutOtherRef.current = defaultLayoutOther 
              }  
            else {
                updateData(extensionJson.customLayouts, defaultLayoutOther) 
                defaultLayoutOtherRef.current = defaultLayoutOther 
              }
}, [defaultLayoutOther] )

const applyLayout = (layoutInfo) => {
  setColumnOrders(layoutInfo.columnOrder);
  setColumnWidths(layoutInfo.columnSizing);
  setColumnVisibility(layoutInfo.columnVisibility);
  fetchData(layoutInfo)
}

const deleteLayout = (identifier, layout) => {
  const newExtensionJson = { ...extensionJson };
  const layoutInfo = newExtensionJson?.[identifier]?.[layout];
  const currentLayout = selectedColumnLayout.split("~")[0];

  const applyDefaultLayout = (layouts, type) => {
    for (const key in layouts) {
      if (layouts[key]?.isDefault) {
        setSelectedColumnLayout(`${key}~${type}`);
        applyLayout(layouts[key]);
        return true; // Found and applied default layout
      }
    }
    return false; // No default layout found
  };

  if (currentLayout === layout) {
    if (layoutInfo?.isDefault) {
      if (applyDefaultLayout(newExtensionJson.preDefinedLayouts, 'preDefinedLayouts')) {
        // Predefined default layout applied
      }
    } else {
      if (!applyDefaultLayout(newExtensionJson.customLayouts, 'customLayouts')) {
        applyDefaultLayout(newExtensionJson.preDefinedLayouts, 'preDefinedLayouts');
      }
    }
  }

  delete newExtensionJson?.[identifier]?.[layout];
  
  updateData(extensionJson.developer 
    ? newExtensionJson.preDefinedLayouts 
    : newExtensionJson.customLayouts);

  setExtensionJson(newExtensionJson);
  setSaveAnchorEl(null);
};



const handleDownload = (rows) => {
  const trueColumnVisibility = Object.keys(columnVisibility)
  
  const csvConfig = mkConfig({    fieldSeparator: ',',    decimalSeparator: '.',    useKeysAsHeaders: true,    filename: selectedColumnLayout,   })

  const rowData = rows.map((row) =>{
    return row.original});
  const filteredRowData = rowData.map((row) =>
      Object.keys(row).reduce((filteredRow, prop) => {
        if (!trueColumnVisibility.includes(prop)) {
          const match = prop.match(/\(([^)]+)\)/);
          const header = match ? match[1] : prop;
          filteredRow[header] = row[prop];
        }
        return filteredRow;
      }, {})
  )

  const lastRow = {}

  Columns.forEach((column) => {   
     if (!trueColumnVisibility.includes(column.accessorKey)) {  
        let columnName

          if (column.accessorKey.startsWith("SUM") || column.accessorKey.startsWith("AGG")) 
            {
                let match = column.accessorKey.match(/\(([^)]+)\)/);
                columnName = match[1]
            }  
          else columnName = column.accessorKey

        if  (column.Footer ) lastRow[columnName] = column.Footer.props.children 
        else lastRow[columnName] = '' 

   }})
  filteredRowData.push(lastRow)

  let reorderedColumns = []
  columnOrder.forEach(column => {
      if (column.startsWith("SUM") || column.startsWith("AGG")) 
        {
            let match = column.match(/\(([^)]+)\)/);
            if (match) reorderedColumns.push(match[1])
        }  
      else reorderedColumns.push(column)
  
    })

  const reorderedRowData = filteredRowData.map(row => {
    const reorderedRow = {}
    reorderedColumns.forEach(key =>   { if (row.hasOwnProperty(key))  reorderedRow[key] = row[key]  })
    return reorderedRow
  });

  // download(csvConfig)(generateCsv(csvConfig)(reorderedRowData));
}

 return (
    <>

    {columnOrder.length > 0 && headers.length > 0 ? <>
    <MaterialReactTable
    // Initial Stages
    columns={Columns}
    data={data} // Use the 'rows' directly as the data
    
    initialState={{ density: "compact" }}
    state={{        isLoading : isLoading,        sorting,        columnSizing,        columnOrder,        columnVisibility,    showProgressBars: progressBar  }}
    // Column Re-Sizing
    enableColumnResizing
    columnResizeMode="onEnd"
    defaultColumn={{ minSize: 100, maxSize: 250 }}
    layoutMode="grid"
    onColumnSizingChange={setColumnWidths}
    columnFilterDisplayMode = 'popover'
    // Css for Table
    muiTableHeadCellProps=  {{        sx: { flex: "0 0 auto", fontSize: { xs: "11px" }, "& .MuiTableSortLabel-icon": { fontSize: "13px" }, font: "bolder" }}}
    muiTableBodyCellProps=  {{        sx: { flex: "0 0 auto", fontSize: { xs: "9px" }  }}}
    muiTableBodyProps=      {{        sx: { "& tr:nth-of-type(odd) > td ": { backgroundColor: "#f5f5f5" }} }}
    muiTableFooterCellProps={{        sx: { flex: "0 0 auto", fontSize: { xs: "11px" }, font: "bolder" }}}
    muiCircularProgressProps={{       color: 'primary',     thickness: 5,      size: 55    }}
    muiSkeletonProps=       {{        animation: 'pulse',   height: 28    }}
    // ToolBars
    enableStickyHeader={true}
    enableStickyFooter={true}
    // Column ordering
    enableColumnOrdering= {false}
    onColumnOrderChange={setColumnOrders}
    //Colum-Hiding
    enableHiding={true}
    onColumnVisibilityChange={setColumnVisibility}
    // Unused default state
    enableColumnFilters={false}
    enableBottomToolbar={false}
    enableFullScreenToggle={false}
    enableGlobalFilterModes={false}
    enableGlobalFilter={false}
    enablePagination={false}
    enablePinning={false}
    enableRowNumbers={false}
    enableDensityToggle= {false}
    enableColumnActions={false}
    enableColumnDragging = {false}
    // Virtualization
    enableColumnVirtualization
    enableRowVirtualization
    onSortingChange={setSorting}
    rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
    rowVirtualizerProps={{ overscan: 5 }}
    columnVirtualizerProps={{ overscan: 2 }}
    // LinearProgress Bar
    muiLinearProgressProps={({ isTopToolbar }) => ({
      color: 'primary',
      variant: 'determinate', //if you want to show exact progress value
      value: progress, //value between 0 and 100
      sx: {
        display: isTopToolbar ? 'block' : 'none', //hide bottom progress bar
      },
    })}
    //Circular Loading


    //Custom Tool bar End side
    // renderToolbarInternalActions={({ table }) => (
    //       <>
    //       {progress ? 
    //         <IconButton title = "Download CSV" onClick={() => handleDownload(table.getRowModel().rows )} sx={{ m: "0px 10px", border: '1.5px solid',borderRadius: '5px','&:hover': { borderColor: 'primary.main'},}} >            
    //           {/* <DownloadOutlined /> */}
    //         </IconButton>
    //       : null}


    //           {/* <Tooltip title='Rearrange/Hide & Show Columns' >   
    //               <IconButton onClick={(e) => handleColumnsPopClick(e)}> <ViewColumnIcon /> </IconButton> 
    //           </Tooltip> */}

    //       </>
    //     )}
    //Custom Tool bar Start side
    renderTopToolbarCustomActions={({table}) => (<>
          {extensionJson ? 
<>
      <Box sx={{ minWidth: 300 , display: 'flex', justifyContent: 'space-between', }}>
        <FormControl size="small" margin="dense" fullWidth>
          <InputLabel id="demo-simple-select-label" sx={{fontSize: 'small'}}>Column Layouts</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedColumnLayout}
                label="Column Layouts"
                onChange={(e) =>handleColumnSelect(e)}
                sx={{'& .MuiSelect-select': { fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', },}}
              >
                <Typography sx={{p: 2, paddingBottom : 0 , fontWeight: 'bold', fontSize: '12px'}}> Pre-Defined Layouts </Typography>
                <Divider orientation="horizontal" />

                {Object.keys(extensionJson.preDefinedLayouts).sort().map((key, index)=>(
                  [
                    <MenuItem sx={{  display: 'flex',  alignItems: 'center', justifyContent: 'space-between', fontSize: '12px'}}
                     key={index} value={key+"~preDefinedLayouts"}>
                      {key} 
                     <div style={{ marginLeft : '10px' }}>
                      {Object.keys(defaultLayoutOther).length > 0 && (defaultLayoutOther.layoutName === key) ? 
                       <>(Default)</>
                        : null 
                      }
                      </div>
                    </MenuItem>
                  ]
                ))}
                <Typography sx={{p: 2, paddingBottom : 0 , fontWeight: 'bold', fontSize: '12px'}}> Custom Layouts </Typography>
                <Divider orientation="horizontal" />
                <Typography sx={{p: 2, fontWeight: 'bold', fontSize: '12px'}}> My Column Layouts </Typography>
                {Object.keys(extensionJson.customLayouts).sort().map((key,index)=>([
                <MenuItem   sx={{  display: 'flex',  alignItems: 'center', justifyContent: 'space-between', fontSize: '12px'}} key={index}  value={key+"~customLayouts"} >
                    {key}
                    <div style={{ marginLeft : '10px' }}>
                      {Object.keys(defaultLayoutOther).length === 0 && extensionJson.customLayouts[key].isDefault ? 
                       <>(Default)</>
                        : null 
                      }

                        {extensionJson.customLayouts[key].columnNotes ?  
                          <Tooltip  title={extensionJson.customLayouts[key].columnNotes} >
                            <DescriptionOutlinedIcon fontSize="small" sx={{margin: '0 5px' }}  />
                          </Tooltip> : null} 

                          <Tooltip title={extensionJson.customLayouts[key].isVisibleToOthers ? 'This layout is visible to the Organization' : 'This layout is Private'}>
                                {extensionJson.customLayouts[key].isVisibleToOthers ?  
                                <VisibilityOutlinedIcon fontSize="small" sx={{margin: '0 5px' }} /> 
                                    : 
                                <VisibilityOffOutlinedIcon fontSize="small" sx={{margin: '0 5px' }} />}
                          </Tooltip>
                    </div>
                </MenuItem>
                ]
              ))}

              
            <Typography sx={{p: 2, fontWeight: 'bold', fontSize: '12px'}}> Other Column Layouts </Typography>
                {Object.keys(extensionJson.otherLayouts).sort().map((key,index)=>([
                <MenuItem   sx={{  display: 'flex',  alignItems: 'center', justifyContent: 'space-between', fontSize: '12px'}} key={index}  value={key+"~otherLayouts"} >
                    {key}
                    <div style={{ marginLeft : '10px' }}>
                        {/* {extensionJson.otherLayouts[key].isDefault ? <>(Default)</> : null}  */}
                        {Object.keys(defaultLayoutOther).length > 0 && (defaultLayoutOther.layoutName === key) ? 
                       <>(Default)</>
                        : null 
                      }
                        {extensionJson.otherLayouts[key].columnNotes ?  
                          <Tooltip  title={extensionJson.otherLayouts[key].columnNotes} >
                            <DescriptionOutlinedIcon fontSize="small" sx={{margin: '0 5px' }}  />
                          </Tooltip> : null} 

                          <Tooltip title={extensionJson.otherLayouts[key].user_displayname}>
                          <AccountCircleSharpIcon />
                          </Tooltip>
                    </div>
                </MenuItem>
                ]
              ))}
              </Select>

        </FormControl>

      <IconButton sx={{marginLeft: 2}} onClick={(e) => handleColumnsPopClick(e)} title= {"Edit Layout - " + selectedColumnLayout.split("~")[0] }> <EditIcon /> </IconButton>

      <IconButton  sx={{marginLeft: 2}}  onClick={(e) => handleLayoutFormClick(e)}  size="small"  title={extensionJson.developer ? "Edit Predefined Layouts" : "Edit Custom Layouts"} 
        disabled={ (extensionJson.developer && Object.keys(extensionJson.preDefinedLayouts).length === 0) || (!extensionJson.developer && Object.keys(extensionJson.customLayouts).length === 0) }
      >
          <EditNoteOutlinedIcon  /> 
      </IconButton>
      {
        extensionJson.developer ? <IconButton sx={{marginLeft: 2}} onClick={(e) => setTotalAnchorEl(e.currentTarget)} title= {"Select Columns For Total"}> <TableRowsIcon /> </IconButton>
        :
        null
      }
      {
        extensionJson.developer ? <IconButton sx={{marginLeft: 2}} onClick={(e) => setDownloadAnchorEl(e.currentTarget)} title= {"Select Columns For Total"}> <TableRowsIcon /> </IconButton>
        :
        null
      }
      </Box>

      <Box sx={{ minWidth: 250, display: 'flex', justifyContent: 'space-between', marginLeft: -20 }}>
        <FormControl size="small" margin="dense" disabled={maxRowsRef.current < 10000} fullWidth>
          <InputLabel id="demo-simple-select-label" sx={{ fontSize: 'small' }}>Displaying</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={maxRowsRef.current < 10000 ? maxRowsRef.current : selectedRowsRef.current}
            label="Displaying"
            onChange={(e) => handlePageLimitSelect(e)}
            sx={{ '& .MuiSelect-select': { fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' } }}
          >
            {[10000, maxRowsRef.current > 20000 ? 20000 : null , maxRowsRef.current].map((value) =>
              value <= maxRowsRef.current ? (
                <MenuItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '12px' }} key={value} value={value} >
                  {value}
                </MenuItem>
              ) : null
            )}
          </Select>
        </FormControl>
        <Typography sx={{ m: 2, fontSize: '12px', whiteSpace: 'nowrap' }}> of {maxRowsRef.current} Rows </Typography>
    </Box>
    </>

:  null}


</>)}
/> 

  <Snackbar open={LayoutAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center'}} autoHideDuration={4000} onClose={handleSnackbar} >
    <Alert onClose={handleSnackbar} severity={LayoutAlertStatus} variant="filled" sx={{ width: '100%' }} >
      {LayoutAlertMsg}
    </Alert>
  </Snackbar>

  <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleCancel} anchorOrigin={{ vertical: 'bottom',horizontal: 'center' }} 
           transformOrigin={{ vertical: 'top',horizontal: 'right' }} PaperProps = {{ style: { display: 'flex', flexDirection: 'row', maxHeight: '90vh', overflowY: 'auto' }}} >
    <Box sx={{padding: 2 , minWidth : 400}}>
      <Paper fullwidth="true" sx={{padding: 2}}>
      <FormControl component="fieldset" fullWidth>
        <Typography variant="h6" display="block" gutterBottom sx={{ padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 2, fontSize: 12 , whiteSpace: 'nowrap' }}>
            {newFormOpen ? 'New layout' : ' Edit ' + ColumnFormStatus + ' - ' + selectedColumnLayout.split("~")[0] }
        </Typography>
    <TextField
                fullWidth 
                id="outlined-basic"     
                label="Layout Name" 
                InputLabelProps={{size : 'small', shrink : true}} 
                required 
                autoComplete="off" 
                variant="outlined" 
                size="small"  
                value={columnLayoutName} 
                onChange={(e) => setColumnLayoutName(e.target.value)} 
                disabled = {editForm}
                inputProps={{style: {fontSize: '12px'}}}
                />
      {
        editForm ?       null       :
        <TextField 
                  fullWidth 
                  label="Layout Notes" 
                  InputLabelProps={{size : 'small', shrink : true}}    
                  size="small"
                  variant="outlined" 
                  multiline
                  rows={3} 
                  value={columnLayoutNotes} 
                  onChange={(e) => setColumnLayoutNotes(e.target.value)}
                  InputProps={{style: {fontSize: '12px' }}}
                  sx={{ marginTop: 2 }} 
                  />
      }

      {editForm ? 
              <FormGroup aria-label="position" row>

              <FormControlLabel
                control={<Checkbox size="small" checked={isDefaultLayout} onChange={(e) => setIsDefaultLayout(e.target.checked)} />}
                label="Make it default"
                labelPlacement="end"
                sx={{'& .MuiFormControlLabel-label' : {fontSize : '12px'}}}
              />
            </FormGroup>
      
      : 
        <FormGroup aria-label="position" row>

        <FormControlLabel
          control={<Checkbox size="small" checked={isVisibleToOthers} onChange={(e) => setIsVisibleToOthers(e.target.checked)} />}
          label="Make visible to Others"
          labelPlacement="end"
          sx={{'& .MuiFormControlLabel-label' : {fontSize : '12px'}}}
        />
        
        <FormControlLabel
          control={<Checkbox size="small" checked={isDefaultColumn} onChange={(e) => setIsDefaultColumn(e.target.checked)} />}
          label="Make it default"
          labelPlacement="end"
          sx={{'& .MuiFormControlLabel-label' : {fontSize : '12px'}}}
        />
      </FormGroup>
      }

  </FormControl>

        <div style={{ marginTop : '10px'}}>
          { !editForm ?
        <Button  sx={{ paddingX : 2, paddingY: 0.75 , fontSize: '10px' , marginRight : 1 }} disabled = {!columnLayoutName} variant="outlined" size="small" onClick={(e) => {saveColumnLayout(e)}} >Save</Button> 
                  :
        <Button  sx={{ paddingX : 2, paddingY: 0.75 , fontSize: '10px' , marginRight : 1 }} variant="outlined" size="small" onClick={(e) => {savedefColumnLayout(e)}} >Save</Button> 
          }
        { !newFormOpen ? 
          <Button  sx={{ paddingX : 2, paddingY: 0.75 ,  fontSize: '10px'  }} disabled = {!columnLayoutName && newFormOpen } variant="outlined" size="small" onClick={(e) => setNewForm(e)} >Save As New</Button>
              : null
        }
        <Button  sx={{ paddingX : 2, paddingY: 0.75 , marginLeft: 1 , fontSize: '10px'  }} variant="outlined" size="small" onClick={(e) => {handleCancel(e)}} >Cancel</Button>
              </div>
    </Paper>
    </Box>

<List sx={{  width: '100%', bgcolor: 'background.paper' , maxHeight: '90vh', overflowY: 'auto'  }}
                subheader={                  
                            <ListSubheader sx={{fontSize: 15, backgroundColor:'#dddddd', padding: 2}}>
                              <Typography sx={{  display:'flex' , fontSize: 15 , fontWeight: 'bold' , alignItems: 'center', justifyContent: 'center' }}>  Rearrange / Hide & Show Columns  </Typography>
                                 <Divider orientation="horizontal" />
                              <div style={{display: 'flex', alignItems: 'center', paddingTop:'10px'}}>
                              <Paper component="form" sx={{ p: 1, display: 'flex', alignItems: 'center'}}>
                                  <InputBase  sx={{ ml: 1, flex: 1 , fontSize: '14px'}} placeholder="Search Columns"  inputProps={{ 'aria-label': 'search' }} value={searchQuery}   onChange={(e)=>handleInputChange(e)} />
                                  <IconButton title ="Clear search" sx={{margin: 0, padding: 0.5}} size="small" onClick={(e) => {setSearchQuery('')}}> <CloseIcon fontSize="small" /> </IconButton>
                              </Paper>
                              <Switch  size="small"  edge="start" sx={{marginLeft : 2}} title={ isMultiCheckSwitch ? "Hide Selected columns" : "Show Selected columns"}  onChange={(e) =>handleBulkToggle(e)}  checked={isMultiCheckSwitch} />
                              <IconButton size="small" title = "Move Up" onClick={(e) => {moveUp(e)}} color="primary" sx={{backgroundColor : 'white', marginLeft : 2}} > <ArrowUpwardIcon /> </IconButton>
                              <IconButton size="small" title = "Move Down" onClick={(e) => {moveDown(e)}} color="primary" sx={{backgroundColor : 'white', marginLeft : 2}}> <ArrowDownwardIcon /> </IconButton>
                              </div>
                        </ListSubheader> }>

                      <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided) => (
                              <div ref={provided.innerRef} {...provided.droppableProps}>
                                {filteredColumns.map((value, index) => {
                                        const labelId = `checkbox-list-label-${value}`;
                                          return (
                                          <Draggable key={value} draggableId={value} index={index}>
                                              {(provided) => (
                                              <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                <ListItem key={value}  disablePadding >
                                                  <IconButton key={index} sx={{marginLeft: 1, marginRight : 1, padding:0 }} > <DragHandleIcon /> </IconButton>
                                                  <Switch size="small"  disabled={fixedColumns.includes(value)}  edge="start" onChange={handleSwitchToggle(value)} checked={!formColumnVisibility.hasOwnProperty(value)} inputProps={{  'aria-labelledby': labelId}}  />
                                                <ListItemButton selected={selectedColumns.includes(value)} role={undefined} onClick={(e) => handleColumnClick(value,e)} dense>
                                                  <ListItemText  id={labelId} primary={`${extractValueInsideParentheses(value)}`} sx={{'& .MuiListItemText-primary':{ fontSize: 10 }}} />
                                                </ListItemButton>
                                                </ListItem>
                                              </div>
                                              )}
                                          </Draggable>
                                          )
                                    })}
                                    {provided.placeholder}
                                </div>
                              )}
                          </Droppable>
                        </DragDropContext>
 </List>
            </Popover>

<Popover id={saveId} open={saveOpen} anchorEl={saveAnchorEl} onClose={handleSaveClose}  anchorPosition={{ top: 75, left: 100 }}  anchorOrigin={{ vertical: 'top',  horizontal: 'left',}} 
  transformOrigin={{vertical: 'top', horizontal: 'left', }} >


<Typography sx={{marginBottom: 1, fontSize: 15, backgroundColor:'#dddddd', padding: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              
                    <span>Edit Column Layouts</span>
            </Typography>
                      <Box sx={{minWidth : 300, minHeight: '30vh', margin: 1}}>
                           <Grid item xs={12} md={6}>
                           <List dense>
                                {extensionJson.developer ?
                                  Object.keys(extensionJson.preDefinedLayouts).map((layout) => (
                                    <ListItem key={layout}>
                                        <>
                                          <ListItemText primary={layout} style={{ fontSize: 12 }} />
                                          <IconButton edge="end" aria-label="edit" onClick={(e) => handleColumnsPopClick(e, layout)}>
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                          <IconButton edge="end" aria-label="delete" onClick={() => deleteLayout('preDefinedLayouts', layout)}>
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </>
                                    </ListItem>
                                  )) :
                                  Object.keys(extensionJson.customLayouts).map((layout) => (
                                    <ListItem key={layout}>
                                        <>
                                          <ListItemText primary={layout} style={{ fontSize: 12 }} />
                                          <IconButton edge="end" aria-label="edit" style ={{ marginRight : 5 }} title= {"Edit Layout - " + layout } onClick={(e) => handleColumnsPopClick(e, layout)}>
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                          <IconButton edge="end" aria-label="delete" title= {"Delete Layout - " + layout }  onClick={() => deleteLayout('customLayouts', layout)}>
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </>
                                    </ListItem>
                                  ))
                                }
                              </List>
                            </Grid>
                            </Box>
</Popover>

<Popover
  id={totalId}  open={totalOpen}  anchorEl={totalAnchorEl}  onClose={handleTotalClose}  anchorOrigin={{ vertical: 'bottom',horizontal: 'center' }} 
  transformOrigin={{ vertical: 'top',horizontal: 'center' }} PaperProps = {{ style: { display: 'flex', flexDirection: 'row', maxHeight: '90vh', overflowY: 'auto' }}} 
>
  <List
    sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: '90vh', overflowY: 'auto', }}
    subheader={
      <ListSubheader sx={{ fontSize: 15, backgroundColor: '#dddddd', padding: 2 }} >
        <Typography  sx={{ display: 'flex', fontSize: 15, fontWeight: 'bold', alignItems: 'center', justifyContent: 'center', }} >
          Select For Column Totals
        </Typography>
        <Divider orientation="horizontal" />
      </ListSubheader>
    }
  >
        <Box sx={{margin: 3}}>

    {columnOrder.map((value) => {
      const labelId = `checkbox-list-label-${value}`;
      return (
        <ListItem sx={{margin: 1}} key={value} disablePadding>
          <Switch size="small" edge="start" onChange={()=> handleSwitchTotalToggle(value)} checked={columnsForTotal.includes(value)} inputProps={{ 'aria-labelledby': labelId }} />
          <ListItemText id={labelId} primary={`${extractValueInsideParentheses(value)}`} sx={{ '& .MuiListItemText-primary': { fontSize: 10 } }} />
        </ListItem>

      );
    })}

</Box>

  </List>
</Popover>

<Popover
  id={totalId}  open={downloadOpen}  anchorEl={downloadAnchorEl}  onClose={handleDownloadClose}  anchorOrigin={{ vertical: 'bottom',horizontal: 'center' }} 
  transformOrigin={{ vertical: 'top',horizontal: 'center' }} PaperProps = {{ style: { display: 'flex', flexDirection: 'row', maxHeight: '90vh', overflowY: 'auto' }}} 
>
  <List
    sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: '90vh', overflowY: 'auto', }}
    subheader={
      <ListSubheader sx={{ fontSize: 15, backgroundColor: '#dddddd', padding: 2 }} >
        <Typography  sx={{ display: 'flex', fontSize: 15, fontWeight: 'bold', alignItems: 'center', justifyContent: 'center', }} >
          Select For Fixed Columns
        </Typography>
        <Divider orientation="horizontal" />
      </ListSubheader>
    }
  >
        <Box sx={{margin: 3}}>

    {columnOrder.map((value) => {
      const labelId = `checkbox-list-label-${value}`;
      return (
        <ListItem sx={{margin: 1}} key={value} disablePadding>
          <Switch size="small" edge="start" onChange={()=> handleSwitchFixedColumnsToggle(value)} checked={fixedColumns.includes(value)} inputProps={{ 'aria-labelledby': labelId }} />
          <ListItemText id={labelId} primary={`${extractValueInsideParentheses(value)}`} sx={{ '& .MuiListItemText-primary': { fontSize: 10 } }} />
        </ListItem>

      );
    })}

</Box>

  </List>
</Popover>


</>
 : null } </>)}



export default MaterialTable
